var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mm-tabs-active-bar",class:`mm-tabs-active-bar__${_vm.rootTabs.tabPosition}`,style:(_vm.barStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }